import React from 'react'

import Layout from '../layouts/en'
import SEO from '../components/seo'

import {
  appendix1,
  appendix2,
  appendix3,
  appendix4,
} from '../data/Appendices'

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="Appendix" />

    <div className="container mt-8 font-normal">
      <div>
        <table className="mb-12 appendices" data-aos="fade-up">
          <colgroup>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="3">I - Published Books or Book Chapters</th>
            </tr>
            <tr>
              <th>Author</th>
              <th>Title</th>
              <th>Publisher</th>
            </tr>
          </thead>

          <tbody>
            {
              appendix1.map((item, i) => (
                <tr key={i}>
                  <td dangerouslySetInnerHTML={{ __html: item.author['en'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.title['en'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.publisher['en'].join('<br/>') }}></td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

      <div>
        <table className="mb-12 appendices" data-aos="fade-up">
          <colgroup>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
            <col style={{ width: '33.3333%', minWidth: '33.3333%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="3">II - Research Published in Academic Journals</th>
            </tr>
            <tr>
              <th>Author</th>
              <th>Title</th>
              <th>Publisher</th>
            </tr>
          </thead>

          <tbody>
            {
              appendix2.map((item, i) => (
                <tr key={i}>
                  <td dangerouslySetInnerHTML={{ __html: item.author['en'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.title['en'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.publisher['en'].join('<br/>') }}></td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

      <div>
        <table className="mb-12 appendices" data-aos="fade-up">
          <colgroup>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="4">III - Papers Presented at Conferences or Published in Conference Proceedings</th>
            </tr>
            <tr>
              <th>Author</th>
              <th>Paper</th>
              <th>Conference</th>
              <th>Place and Date</th>
            </tr>
          </thead>

          <tbody>
            {
              appendix3.map((item, i) => (
                <tr key={i}>
                  <td dangerouslySetInnerHTML={{ __html: item.author['en'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.paper['en'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.conference['en'] }}></td>
                  <td dangerouslySetInnerHTML={{ __html: item.placeAndDate['en'] }}></td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

      <div>
        <table className="mb-4" data-aos="fade-up">
          <colgroup>
            <col style={{ width: '75%', minWidth: '75%' }}></col>
            <col style={{ width: '25%', minWidth: '25%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th colSpan="2">IV - Scholarships and Fellowships</th>
            </tr>
            <tr>
              <th>Scholarship</th>
              <th>Number of Recipients</th>
            </tr>
          </thead>

          <tbody>
            {
              appendix4.map((item, i) => {
                if (item.count === null) {
                  return (
                    <tr key={i}>
                      <td colSpan="2" className="font-bold bg-gray-400">{ item.name['en'] }</td>
                    </tr>
                  )
                }
                return (
                  <tr key={i}>
                    <td className={`${item.bold ? 'font-bold bg-gray-400' : ''}`} dangerouslySetInnerHTML={{ __html: item.name['en'] }}></td>
                    <td className={`${item.bold ? 'bg-gray-400' : ''} text-right`} dangerouslySetInnerHTML={{ __html: item.count }}></td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>

      <div className="text-base my-4 mb-12">
        Remark: The above only counts the new recipients in the academic year and renewal cases are not included.
      </div>
    </div>
  </Layout>
)

export default IndexPage
